import { createReducer, on } from "@ngrx/store"
import {
    resetSaleObjectState,
    setCreateToSaleState,
    setIsEditFormSaleState,
    setSaleState
} from "./sale.actions"

export type SaleState = {
    create?: {
        customer?: any,
        vehicle?: any,
        payment?: any,
        receipt?: any,
        attachment?: any
    },
    edit?: any,
    isEdit?: boolean
}

const initialState: SaleState = {}

export const saleReducer = createReducer(
    initialState,
    on(
        setCreateToSaleState,
        (state, { create }) => {
            return {
                ...state,
                create: {
                    ...state.create,
                    ...create
                }
            }
        }
    ),
    on(
        resetSaleObjectState,
        (state) => {
            return {}
        }
    ),
    on(
        setIsEditFormSaleState,
        (state, { isEdit }) => {
            return {
                ...state,
                isEdit
            }
        }
    ),
    on(
        setSaleState,
        (state, { sale }) => {
            return {
                ...state,
                ...sale
            }
        }
    )
)
